/** Returns a new object with all keys in lowercase and without whitespaces */ 
export const keysToLowerCase = (jsonObj: any) => {
    if (jsonObj && typeof jsonObj === 'object') {
        return Object.keys(jsonObj).reduce((acc: any, key) => {        
            // SAFE: normalizes internal API payload field keys, not user/localized text
            acc[key.toLowerCase().replace(/\s/g, '')] = jsonObj[key];
            return acc;
        }, {});
    }
    return jsonObj;
}

// Sortable Object -> Record<string, any>;
/** **Returns a new array of objects sorted by the specified key in natural order**
 * - _If the property from one of the objects is null, it will be placed last in the sorted array._
 * @param array - The array of objects to sort
 * @param property - The key to sort by
 * @param ascending - Whether to sort in ascending order (default: true)
 */
export const naturalSortObjectsArrayByKey = <T extends Record<string, any>>(
    array: T[],
    property: keyof T,
    ascending: boolean = true // Default to ascending order
  ): T[] => {
    const collator = new Intl.Collator('en', {
      numeric: true,
      sensitivity: 'base',
    });
  
    return array.sort((a, b) => {
      const aValue = a[property];
      const bValue = b[property];
  
      // Handle null values
      if (aValue === null && bValue === null) return 0; // both are null, consider equal
      if (aValue === null) return 1; // nulls come last
      if (bValue === null) return -1; // nulls come last
  
      const comparison = collator.compare(String(aValue), String(bValue));
  
      return ascending ? comparison : -comparison; // Reverse order if descending
    });
  };
